<template src="./template.html"/>

<script>
import { MessageBlock, Stage } from '@neurotrack/web-shared-components'
import { ntDate } from '@neurotrack/web-core'
import TrailsNode from '../TrailsNode/TrailsNode.vue'

const nodeOffsetInPx = 30
const viewWidth = 900
/** This should be the max height of exams */
const viewHeight = 300

export default {
  components: { TrailsNode, MessageBlock, Stage },
  data() {
    return {
      context: null,
      currentNode: null,
      completed: false,
      error: false,
      defaultHeader: '',
      defaultBody: '',
      viewWidth,
      viewHeight
    }
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    isPractice: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    data() {
      this.startExam()
    },
    error(isError) {
      if (isError) {
        this.clearHeader()
      }
    }
  },
  computed: {
    messageHeader() {
      return this.error
        ? this.$t('path_points_tutorial_incorrect_header')
        : this.defaultHeader
    },
    messageBody() {
      return this.error
        ? this.$t('path_points_tutorial_incorrect_body')
        : this.defaultBody
    },
    nodes() {
      if (!this.data) {
        return []
      }
      const n = this.data.body.nodes.map(node => ({
        x: node.x * viewWidth - nodeOffsetInPx,
        y: node.y * viewHeight - nodeOffsetInPx,
        value: node.label,
        index: node.index
      }))
      return n
    }
  },
  mounted() {
    this.initialize()
  },
  methods: {
    clearHeader() {
      this.defaultHeader = ''
      this.defaultBody = ''
    },
    initialize() {
      const canvas = document.getElementById('trails-canvas')
      this.context = canvas.getContext('2d')
      this.context.imageSmoothingEnabled = true
      this.context.strokeStyle = '#0065FF'
      this.context.lineWidth = 3
      this.defaultHeader = this.data?.header?.headline?.text || ''
      this.defaultBody = this.data?.header?.content?.text || ''
      this.startExam()
    },
    startExam() {
      this.$emit('examstarted', {
        trial_start_time: ntDate.now(),
        ...this.data
      })
    },
    completeExam() {
      this.$emit('examfinished', { trial_end_time: ntDate.now() })
    },
    linkNodes(e, idx) {
      // TODO revisit to remove passing extra args, need the value in the output data ~JB
      const { target } = e
      const isFirst = this.currentNode === null && idx === 0

      if (this.currentNode === idx - 1 || isFirst) {
        if (isFirst) {
          this.clearHeader()
        }
        target.classList.add('correct')
        this.error = false
        const { x, y } = this.nodes[idx]
        if (this.currentNode !== null) {
          const { x: prevX, y: prevY } = this.nodes[this.currentNode]
          this.context.beginPath()
          this.context.moveTo(prevX + nodeOffsetInPx, prevY + nodeOffsetInPx)
          this.context.lineTo(x + nodeOffsetInPx, y + nodeOffsetInPx)
          this.context.stroke()
          this.context.closePath()
        }
        if (idx === this.nodes.length - 1) {
          this.completed = true
          this.completeExam()
        }
        this.currentNode = idx
      } else {
        target.classList.add('wrong')
        this.error = true
        setTimeout(() => target.classList.remove('wrong'), 1050)
      }
      this.$emit('examaction', {
        event_button_index: idx,
        event_time: ntDate.now(),
        event_result: !this.error
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
